import { render, staticRenderFns } from "./bobot_data_produksi.vue?vue&type=template&id=60f94fde&"
import script from "./bobot_data_produksi.vue?vue&type=script&lang=js&"
export * from "./bobot_data_produksi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports